import moment from 'moment';

export const humaniseDateTime = (raw) => {
    if (!raw) return null;
    return moment(raw).format('DD-MMM-YYYY HH:mm');
};

export const humaniseDate = (raw) => {
    if (!raw) return null;
    return moment(raw).format('DD-MMM-YYYY');
};

export const Comparators = {
    dateComparator: (filterDate, cellValue) => {
        const date1 = new Date(filterDate);
        const date2 = new Date(cellValue);

        if (date2 < date1) {
            return -1;
        }
        if (date2 > date1) {
            return 1;
        }
        return 0;
    },
};

export const dateTimeColProps = {
    width: 165,
    comparator: Comparators.dateComparator,
    filter: 'agDateColumnFilter',
    filterParams: {comparator: Comparators.dateComparator},
    valueGetter: (params) => {
        if (!params.data) return '';
        const {field} = params.colDef;
        if (!params.data[field]) return '-';
        return humaniseDateTime(params.data[field]);
    },
};

export const dateColProps = {
    ...dateTimeColProps,
    valueGetter: (params) => {
        if (!params.data) return '';
        const {field} = params.colDef;
        if (!params.data[field]) return '-';
        return humaniseDate(params.data[field]);
    },
};


export const numericColProps = {
    type: 'numericColumn',
    filter: 'agNumberColumnFilter',
};
